// extracted by mini-css-extract-plugin
export default {"coins_owned":"CoinsOwned_coins_owned__ZQB4W","coins_owned_card":"CoinsOwned_coins_owned_card__ZvfkT","no_coins":"CoinsOwned_no_coins__69418"};